export class PatientResponsibility{
    deductibleDue:number = 0;
    coInsuranceDue:number = 0;
    copayDue:number = 0;
    collectFromPatient:number = 0;
    changeNote:string = '';
    changeNoteCategory:string = '';
}